export default {
    namespaced: true,

    state: {

        defaultSettings: [{
                name: 'Shipping',
                description: 'Shipping with leading Australian carriers',
                group_min_weight: 0,
                group_max_weight: 29.9,
                question_ids: '13',
                margin_types: "n",
                value: 0,

            },
            {
                name: 'Tailgate Delivery',
                description: 'Receiver does NOT have a forklift',
                group_min_weight: 30,
                group_max_weight: 9999,
                question_ids: '13,7',
                margin_types: "n",
                value: 0,
            },
            {
                name: 'Forklift At Delivery Point',
                description: 'Receiver has a forklift to unload items from truck',
                group_min_weight: 30,
                group_max_weight: 9999,
                question_ids: '',
                margin_types: "n",
                value: 0,
            }
        ],

        qouteForm: {
            id: null,
            amount: "0",
            margin_type: null,
            rounding: "0",
            integration_id: null,
            is_residential: null,
            is_origin_use: null,
            add_transit_days: "0"
        },

        boxForm: {
            id: null,
            type: null,
            box_type: null,
            weight: null,
            height: null,
            length: null,
            width: null,
            integration_id: null,
            custom_boxes: [],
            dimensional_packing: {
                packOversizedItemIndividually: true,
                packListedSkuInOwnBox: false,
                skusInOwnBox: '',
                boxes: []
            },
            matching_skus: null,
            formType: []
        },

        systemEndpoint: {
            box: '/api/live-rates',
        },

        shopifyEndpoint: {
            box: '/ecommerce',
        },

        token: null,
        shopifySessiontoken: "",
    },

    mutations: {
        SET_QOUTE_FORM(state, form) {
            state.qouteForm = form
        },

        SET_BOX_FORM(state, form) {
            state.boxForm = form
        },

        RESET_QOUTE_FORM(state) {
            state.qouteForm = {
                id: null,
                amount: "0",
                margin_type: null,
                rounding: "0",
                integration_id: null,
                is_residential: null,
                is_origin_use: null
            }
        },

        RESET_BOX_FORM(state) {
            state.boxForm = {
                id: null,
                type: null,
                box_type: null,
                weight: null,
                height: null,
                length: null,
                width: null,
                custom_boxes: [],
                dimensional_packing: {
                    packOversizedItemIndividually: true,
                    packListedSkuInOwnBox: false,
                    skusInOwnBox: '',
                    boxes: []
                },
                matching_skus: null,
                formType: []
            }
        },

        ADD_CUSTOM_BOX(state) {
            state.boxForm.custom_boxes.push({
                sku: '',
                quantity: '',
                itemType: '',
                weight: '',
                limit: ''
            })
        },

        ADD_DIMENSIONAL_BOX(state) {
            state.boxForm.dimensional_packing.boxes.push({
                name: '',
                itemType: 'Carton',
                length: '',
                width: '',
                height: ''
            })
        },

        SET_TOKEN(state, token) {
            state.token = token
        },

        SET_SHOPIFY_SESSION_TOKEN(state, token) {
            state.shopifySessiontoken = token
        }
    },

    actions: {
        setQouteForm({ commit }, data) {
            commit("SET_QOUTE_FORM", data)
        },

        setBoxForm({ commit }, data) {
            commit("SET_BOX_FORM", data)
        },

        resetQouteForm({ commit }) {
            commit("RESET_QOUTE_FORM")
        },

        resetBoxForm({ commit }) {
            commit("RESET_BOX_FORM")
        },

        resetForm({ commit }) {
            commit("RESET_BOX_FORM")
            commit("RESET_QOUTE_FORM")
        },

        addCustomBox({ commit }) {
            commit("ADD_CUSTOM_BOX")
        },

        addDimensionalBox({ commit }) {
            commit("ADD_DIMENSIONAL_BOX")
        },

        setToken({ commit }, data) {
            commit("SET_TOKEN", data)
        },

        setShopifySessionToken({ commit }, data) {
            commit("SET_SHOPIFY_SESSION_TOKEN", data)
        },
    },

    getters: {
        getQouteForm(state) {
            return state.qouteForm
        },

        getBoxForm(state) {
            return state.boxForm
        },

        getDefaultSettings(state) {
            return state.defaultSettings
        },

        getSystemEndpoint(state) {
            return state.systemEndpoint
        },

        getShopifyEndpoint(state) {
            return state.shopifyEndpoint
        },

        getTokenData(state) {
            return state.token
        },

        getShopifySessionToken(state) {
            return state.shopifySessiontoken
        },

        getShopifyUserId(state) {
            const token = state.shopifySessiontoken;
            if (typeof token !== 'string') return; // Ensure token is a string

            const parts = token.split('.');
            if (parts.length === 3 &&  // token must have 3 parts
                parts.every(part => part.length > 0)) { // all parts must be non-empty
                const payload = JSON.parse(atob(parts[1]));
                return parseInt(payload.sub, 10); // Convert to integer
            }
            return;
        }
    },

}
